export default String.raw`
$(document).ready(()=>{
    app.sliderInit(".manufactures__swiper", ".manufactures__next", ".manufactures__prev", ".manufactures-pause-button");
});
`